import React, { useMemo } from 'react';
import TranscriptLink from './TranscriptLink';
import { useAllProjectTranscripts } from 'hooks/transcripts/queries';

const TranscriptLinks = ({ projectID, isOnUserPage, transcriptID, onLinkClick }) => {
  const { data: transcripts, error, isLoading } = useAllProjectTranscripts(projectID, { enabled: !!projectID && !isOnUserPage });

  // Helper function to get display name for transcript
  const getTranscriptDisplayName = (transcript) => {
    if (!transcript.name || transcript.name.trim() === '') {
      return 'Untitled';
    }
    return transcript.name;
  };

  // Sort transcripts by name, memoized to avoid unnecessary re-renders
  const sortedTranscripts = useMemo(() => {
    if (!transcripts) return [];

    return [...transcripts].sort((a, b) => {
      const nameA = getTranscriptDisplayName(a);
      const nameB = getTranscriptDisplayName(b);
      return nameA.localeCompare(nameB);
    });
  }, [transcripts]);

  if (isOnUserPage || !transcripts || sortedTranscripts.length === 0) {
    return null;
  }

  return sortedTranscripts.map((transcript) => (
    <TranscriptLink
      key={transcript.id}
      selected={transcriptID === transcript.id}
      transcriptID={transcript.id}
      onLinkClick={onLinkClick}
    >
      {getTranscriptDisplayName(transcript)}
    </TranscriptLink>
  ));
};

export default TranscriptLinks;